const sorting = [
	{
		label: "Belum dikonfirmasi",
		name: "sorting",
		value: JSON.stringify({
			sortBy: "waktu_konfirmasi",
			orderBy: "DESC",
		}),
		id: "sorting-1",
	},
	{
		label: "Sudah dikonfirmasi",
		name: "sorting",
		value: JSON.stringify({
			sortBy: "waktu_konfirmasi",
			orderBy: "ASC",
		}),
		id: "sorting-2",
	},
	{
		label: "Permintaan terbaru",
		name: "sorting",
		value: JSON.stringify({
			sortBy: "created_at",
			orderBy: "DESC",
		}),
		id: "sorting-3",
	},
	{
		label: "Permintaan terlama",
		name: "sorting",
		value: JSON.stringify({
			sortBy: "created_at",
			orderBy: "ASC",
		}),
		id: "sorting-4",
	},
];

export default sorting